module.exports = __webpack_public_path__ + "img/img4.4a0da8ba.jpg";